import { AxiosError } from 'axios';

import { company } from '~/company/Company';
import { orderStore } from '~/stores';

/**
 * Catalogue query params for the warehouse dimension. LMS companies
 * (`hasNewLogistics`) are served all-warehouse stocks and must NOT send a
 * code; for every other company the catalogue still requires one and answers
 * 404 without it.
 */
export const catalogWarehouseParam = (
  warehouse?: string,
): { warehouseCode?: string } =>
  company.hasNewLogistics
    ? {}
    : { warehouseCode: warehouse ?? orderStore.etaWarehouseCode };

/** A 4xx from a request sent without a warehouse code: the backend still wants one. */
export const isClientError = (error: unknown): boolean => {
  const status =
    error instanceof AxiosError ? error.response?.status : undefined;
  return !!status && status >= 400 && status < 500;
};

/**
 * Warehouse for endpoints that insist on one. LMS companies pin their default
 * code: the ETA answers with a virtual warehouse the catalogue does not know.
 */
export const requiredWarehouseCode = (): string =>
  company.hasNewLogistics
    ? company.config.warehouse.default
    : orderStore.etaWarehouseCode;

/**
 * Best single-warehouse quantity from an all-warehouse stock map. Stands in
 * for `sellable` on LMS responses, which no longer carry it — the V3
 * calculation routes across warehouses, so the best one is what is orderable.
 */
export const maxWarehouseSellable = (
  sellableWarehouses: Record<string, string | number> | null | undefined,
): number =>
  Math.max(
    0,
    ...Object.values(sellableWarehouses ?? {}).map(
      (value) => Number(value) || 0,
    ),
  );
